import Vue from 'vue';
import Vuex from 'vuex';
import {
  application,
  category,
  location,
  payment,
  order,
  user,
} from '@stefna/quasar-pilot-core';
import layout from './layout';

Vue.use(Vuex);
export default async function () {
  return new Vuex.Store({
    modules: {
      application,
      category,
      location,
      payment,
      order,
      user,
      layout,
    },
  });
}
